import { render, staticRenderFns } from "./derate-manage-pending.vue?vue&type=template&id=749e0598&scoped=true"
import script from "./derate-manage-pending.vue?vue&type=script&lang=ts"
export * from "./derate-manage-pending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749e0598",
  null
  
)

export default component.exports